<template>
  <div>
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      :finish-button-text="$t('site.finish')"
      :back-button-text="$t('site.back')"
      :next-button-text="$t('site.next')"
      class="steps-transparent mb-3"
      @on-complete="formSubmitted"
    >
      <b-card>
        <tab-content
          title="المحاضرة بالمخطط التعليمي "
          icon="fas fa-calendar-alt"
          id="4"
        >
          <b-row>
            <!-- time picker -->
            <b-col md="6">
              <b-form-group>
                <h5>تبدأ في</h5>
                <flat-pickr
                  v-model="data.start_in"
                  class="form-control"
                  :config="config"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <h5>الترم الدراسي</h5>
                <b-form-select
                  v-model="data.semester_num"
                  label-field="name"
                  value-field="id"
                  :options="numOfSemesters"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </tab-content>

        <tab-content
          title="إختيار نوع المحاضرة "
          icon="fab fa-phabricator"
          id="1"
          :before-change="() => validateStep('type')"
        >
          <types ref="type" />
        </tab-content>
        <tab-content
          title="  بيانات المحاضرة"
          icon="fas fa-server"
          id="2"
          :before-change="() => validateStep('details')"
        >
          <Details ref="details" />
        </tab-content>
        <tab-content
          v-if="data.type != 'direct_lectures'"
          title="المحاضرة "
          icon="fas fa-book-reader"
          id="3"
          :before-change="() => validateStep('lecture')"
        >
          <lecture-vue ref="lecture" :accept="accept" :type="data.type" />
        </tab-content>
      </b-card>
    </form-wizard>
  </div>
</template>
<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import flatPickr from "vue-flatpickr-component";

import Types from "./components/Types.vue";
import Details from "./components/Details.vue";
import lectureVue from "./components/Lecture.vue";
import Auth from "@/Apis/Auth";
import { Arabic } from "flatpickr/dist/l10n/default.js";
import EduContentController from "@/Controllers/EduContentController";
import SemesterController from "@/Controllers/SemesterController";

export default {
  components: {
    FormWizard,
    TabContent,
    vSelect,
    ToastificationContent,
    lectureVue,
    flatPickr,
    Types,
    Details,
  },

  data() {
    return {
      data: {},
      accept: "",
      numOfSemesters: [],
      config: {
        enableTime: true,
        dateFormat: "Y-m-d H:i",
        inline: true,
        minDate: "today",
        // locale: Arabic,

        onChange: function (date) {
          if (date.length == 2) {
            dates = date;
            // interact with selected dates here
          }
        },
      },
    };
  },
  async created() {
    this.data = { edu_course_id: 3, h5p_content_id: 0, type: "voice_lectures" };
    let ed = Auth.CurrentEduProgram();

    this.numOfSemesters = await new SemesterController().GetAll({
      filter: "edu_program_id|" + ed.id,
    });
  },
  methods: {
    async validateStep(name) {
      let refToValidate = this.$refs[name];
      let data = await refToValidate.returnData();
      console.log(data);

      if (!data.valid) return false;
      console.log(data);
      if (name == "type") {
        this.data.type = data.type;
        this.accept = data.accept;
      } else if (name == "details") {
        this.data.name = data.data.name;
        this.data.duration = data.data.duration;
        this.data.description = data.data.description;
      } else if (name == "lecture") {
        if (
          this.data.type == "voice_lectures" ||
          this.data.type == "interactive_video_lectures"
        ) {
          this.data.h5p_content_id = data.h5p_content_id;
        } else if (this.data.type != "direct_lectures") {
          this.data.file = data.file;
        }
      }
      return true;
    },
    async formSubmitted() {
      let duration = this.data.duration.split(":");
      var end_in = new Date(this.data.start_in);
      end_in.setHours(end_in.getHours() + parseInt(duration[0]));
      end_in.setSeconds(end_in.getSeconds() + parseInt(duration[1]));
      this.data.end_in = end_in.toISOString().slice(0, 19).replace("T", " ");
      this.data.wizard = true;
      this.data.room_id = localStorage.getItem("room");
      let res = await new EduContentController(this.data.edu_course_id).From(
        this.data,
        "FormData"
      );
      if (res) {
        this.$router.push({ name: "Home" });
      }
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
